import s from "./AccessoriesToolbar.module.css";

export default function AccessoriesToolbar({
  categories,
  activeCategory,
  onCategoryChange,
  sortBy,
  onSortChange,
}) {
  return (
    <div className={s.toolbar}>
      <div className={s.chips}>
        {categories.map((cat) => (
          <button
            key={cat.id}
            type="button"
            className={activeCategory === cat.id ? s.chipActive : s.chip}
            aria-pressed={activeCategory === cat.id}
            onClick={() => onCategoryChange(cat.id)}
          >
            {cat.label}
            <span className={s.count}>
              {String(cat.count).padStart(2, "0")}
            </span>
          </button>
        ))}
      </div>
      <label className={s.sort}>
        Sort
        <select
          className={s.sortSelect}
          value={sortBy}
          onChange={(e) => onSortChange(e.target.value)}
        >
          <option value="curated">Featured</option>
          <option value="priceAsc">Price: Low to High</option>
          <option value="priceDesc">Price: High to Low</option>
          <option value="newest">Newest</option>
        </select>
      </label>
    </div>
  );
}
